import React, { useEffect, useState } from 'react';
import './login.css'
import { useForm } from "react-hook-form"
import axios from "axios";
import { useNavigate } from 'react-router-dom'
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

function Login({ IP }) {
    const navigate = useNavigate()
    const [loginError, setLoginError] = useState("")
    const [captchaVerified, setCaptchaVerified] = useState(false)
    const { register, handleSubmit, formState: { errors } } = useForm();
    const login = async (loginCredentials) => {
        await axios.post(`http://${IP}/login`, loginCredentials)
            .then((response) => {
                if (response.data.error === false) {
                    sessionStorage.removeItem("token")
                    sessionStorage.removeItem("msg")
                    sessionStorage.removeItem("userObj")
                    sessionStorage.setItem("msg", response.data.msg)
                    sessionStorage.setItem("token", response.data.Token);
                    sessionStorage.setItem("userObj", JSON.stringify(response.data.UserObj))
                    if (response.data.msg == "Student Login Success")
                        navigate("/student/dashboard")
                    else if (response.data.msg == "Admin%%Logi%%Success?adminLoggedIn@#$%$@")
                        navigate("/admin/dashboard")
                    else if (response.data.msg == "Teacher%%Login%%Success?mentorLoggedIn!!@#$")
                        navigate("/fs-teacher/dashboard")
                    else
                        navigate("/")
                }
                else if (response.data.error === true) {
                    setLoginError(response.data.msg)
                    // notifyError(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error);
                // alert("Something went wrong while login");
            });
    }

    const [captchaError, setCaptchaError] = useState("")
    const verifyCaptcha = async (sitekeyToken) => {
        await axios.post(`http://${IP}/verifyCaptcha`, sitekeyToken)
            .then((res) => {
                if (res.data.msg === "Token verified successfully") {
                    setCaptchaVerified(!captchaVerified)
                    setCaptchaError("")
                }
                else if (res.data.msg === "Invalid Captcha!") {
                    setCaptchaError("Invalid Captcha!")
                }
            })
            .catch(err => console.log(err))
    }

    const notifyError = (msg) =>
        toast.error(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    return (
        <div>
            <form className='form mt-5 m-auto mb-2' onSubmit={handleSubmit(login)}>

                <h4 className='login'>LOGIN</h4>

                {
                    loginError != "" &&
                    <div>
                        <div className="alert alert-danger p-2 mt-2 " role="alert">
                            <p className='text-center p-0 ps-2 m-0'>{loginError}</p>
                        </div>
                    </div>
                }

                {/* <div className='form-group'>
                    <label htmlFor="username"><small>Username</small></label>                    
                    <input type="text" id="username" className="form-control" placeholder="Username" {...register("username", { required: true })} />
                    {errors.username && <small className='text-danger'>Username is required</small>}
                </div>

                <div className='form-group'>
                    <label htmlFor="password"><small>Password</small></label>
                    <input type="password" id="password" className="form-control" placeholder="Password" {...register("password", { required: true })} />
                    {errors.password && <small className='text-danger'>Password is required</small>}
                </div> */}

                <div className='mb-4'>
                    <TextField type='text'
                        inputProps={{
                            style: {
                                paddingLeft: 10,
                                paddingBottom: 10,
                                paddingTop: 10,
                                letterSpacing: 0.8,
                            }
                        }}
                        id="outlined-basic" label="Username" variant="standard" autoCorrect={false} autoCapitalize={false} fullWidth={true} {...register("username", { required: true })} />
                    {errors.username && <small className='text-danger'>Username is required</small>}
                </div>
                <div className='mb-2'>
                    <TextField type='password'
                        inputProps={{
                            style: {
                                paddingLeft: 10,
                                paddingBottom: 10,
                                paddingTop: 10,
                                letterSpacing: 0.8
                            }
                        }}
                        id="standard-basic" label="Password" variant="standard" autoCorrect={false} autoCapitalize={false} fullWidth={true} {...register("password", { required: true })} />
                    {errors.password && <small className='text-danger'>Password is required</small>}
                </div>

                {/* <div className="mt-4">
                    <span><a href='/forgot-password'><small>Forgot Password?</small></a></span>
                </div> */}
                <div className='form-group'>
                    <Button type='submit' sx={{ py: 1 }} variant="contained" fullWidth={true}>
                        LOGIN
                    </Button>
                    {/* <button className='btn btn-success w-100 login-button'>LOGIN</button> */}
                </div>
            </form>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}

export default Login